import { WelcomeForm } from '@Pages/passwordless/welcome/welcomeForm/WelcomeForm.tsx';
import WelcomeRankingBanner from '@Assets/banners/welcome-ranking.svg';
import { FontWeight, Heading } from '@lili/lili-frontend-common';
import { useTranslation } from 'react-i18next';
import { ValuesProposalPasswordless } from './components/valueProposal/ValuesProposalPasswordless.tsx';
import { DirectValuesProposal } from '@Pages/passwordless/welcome/components/valueProposal/DirectValuesProposal.tsx';
import { useBoundStore } from '@Store/useBoundStore.ts';
import { twMerge } from 'tailwind-merge';
import { DirectWelcomeHeader } from '@Pages/passwordless/welcome/components/DirectWelcomeHeader.tsx';

export const WelcomePage = () => {
  const { t } = useTranslation();
  const isEmbedded = useBoundStore((state) => state.onboardingSlice.getIsEmbedded());

  return (
    <div className='flex flex-col pc-sm:flex-row items-center w-full h-dvh overflow-scroll fade-in'>
      <div className='flex justify-center w-full pc-sm:basis-1/2 shrink-0 h-fit pc-sm:h-full bg-surface-primary-bw-00 pt-[50px] pb-[64px] px-[16px] md:px-[24px]'>
        <div className='flex flex-col max-w-[420px] w-full '>
          <div className='mb-[24px]'>
            {isEmbedded ? (
              <Heading.H3 fontWeight={FontWeight.SEMIBOLD}>
                {t('pages.homePasswordless.title')}
              </Heading.H3>
            ) : (
              <DirectWelcomeHeader />
            )}
          </div>
          <WelcomeForm />
          <img
            className='w-[320px] mt-[40px] mx-auto'
            src={WelcomeRankingBanner}
            alt='Trust Pilot'
          />
        </div>
      </div>
      <div
        className={twMerge(
          'flex justify-center w-full pc-sm:basis-1/2 shrink-0 h-fit sm:h-full border-l-[1px] sm:border-l-[0px] border-outline-primary-bw-03',
          isEmbedded ? 'bg-surface-brand-action-00' : 'bg-surface-brand-action-05'
        )}>
        <div className='h-full w-full max-w-[590px] py-[24px] sm:px-[32px] px-[24px] pt-[48px] pc-sm:py-[100px]'>
          {isEmbedded ? <ValuesProposalPasswordless /> : <DirectValuesProposal />}
        </div>
      </div>
    </div>
  );
};
